import styled from 'styled-components'

export const Flex = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  background-color: #fff;
  margin-top: 10px;
`
